import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CountryISO, SearchCountryField, } from '@justin-s/ngx-intl-tel-input';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../../../services/auth.service';
import { FlagService } from '../../../../shared/services/flag.service';
import { FlagType } from '../../../../shared/utils/enums';
import { civilityOptions } from '../../../../shared/utils/data/etablissments-data';
import { EstablishmentService } from '../../../../services/establishment.service';
import { User } from '../../../../models/User';

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrl: './add-user.component.scss'
})
export class AddUserComponent implements OnInit {
  preferredCountries: CountryISO[] = [CountryISO.France];
  form: FormGroup;
  loading = false;
  images: string[] = [];
  phoneMaxLength: number = 10;
  phoneNumber: string | undefined;
  user: User | null;
  agencyId: number;

  constructor(
    public dialogRef: MatDialogRef<AddUserComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private agencyService: EstablishmentService,
    private fb: FormBuilder,
    private auth: AuthService,
    private flag: FlagService,
  ) {
    this.user = this.auth.user;
    this.getAgencyByEmail(this.user!.email);
  }

  ngOnInit() {
    this.form = this.fb.group({
      id: [null],
      title: ['', Validators.required],
      firstName: ['', Validators.required],
      fonction: ['', Validators.required],
      lastName: ['', Validators.required],
      mail: ['', [Validators.required, Validators.email]],
      numTel: ['', Validators.required],
      // motDepasse: [
      //   '',
      //   [Validators.required, Validators.pattern(
      //     '^(?=.*[A-Z])(?=.*[a-z])(?=.*\\d)(?=.*[!@#$%^&*/])[A-Za-z\\d!@#$%^&*/]{8,}$'
      //   ),],
      // ],
      photo1: [''],
      photo2: ['']
    });
    if (this.data) {
      console.log("this.data : ", this.data);
      this.phoneNumber = this.data?.numTel;

      this.form.patchValue(this.data)
      if (this.data.image) {
        this.images = [this.data.image];
      }
      if (this.data.photo2) {
        this.images.push(this.data.photo2)
      }
    }
  }

  // item.numTel = a?.numTel?.internationalNumber;

  addContact() {
    const numTel = this.form.get('numTel')?.value?.number.replace(/\s/g, '');
    this.loading = true;
    this.phoneNumber = numTel;
    const body = this.form.value;
    body.numTel = numTel;
    body.fullnamepersonnecontact = this.form.value.firstName + ' ' + this.form.value.lastName
    body.fonctionpersonnecontact = this.form.value.fonction;
    if (!this.data) { this.createUser(); }
    else {
      this.updateUser();
    }
  }

  getImage(images: string[]) {
    const photot1 = this.form.get('photo1')
    photot1?.patchValue('')
    if (images[0]) {
      photot1?.patchValue(images[0])
    }
  }
  onInputChange(event: any) {
    const inputNumber = event?.number;

    if (!inputNumber) return;


    if (inputNumber.startsWith('0')) {
      this.phoneMaxLength = 10;
    } else {
      this.phoneMaxLength = 9;

    }
    if (inputNumber.length > this.phoneMaxLength) {
      this.phoneNumber = inputNumber.slice(0, this.phoneMaxLength);
      this.form.get('phone')?.setValue(this.phoneNumber);
    } else {
      this.phoneNumber = inputNumber;
    }
  }
  protected readonly SearchCountryField = SearchCountryField;
  protected readonly CountryISO = CountryISO;
  protected readonly civilityOptions = civilityOptions;

  createUser() {
    this.loading = true;
    console.log("this.form.get('photo1')?.value : ", this.form.get('photo1')?.value);
    // motDepasse field commented out -- generate a throwaway password for the backend.
    const randomPassword = this.generateRandomPassword();
    const body = {
      email: this.form.get('mail')?.value,
      password: randomPassword,
      password_confirmation: randomPassword,
      kind: "AGENCY_USER",
      // agency id must be fetched from the list of current agencies
      // in this case, the agency id is always the main agency id , and that's wrong
      agency_id: this.agencyId,
      title: this.form.get('title')?.value,
      first_name: this.form.get('firstName')?.value + ' ' + this.form.get('lastName')?.value,
      last_name: this.form.get('fonction')?.value,
      phone_number: this.form.get('numTel')?.value?.number.replace(/\s/g, ''),
      image: (this.form.get('photo1')?.value == "") ? this.data.image : this.form.get('photo1')?.value
    }
    this.agencyService.addAgencyUser(body).subscribe({
      next: () => {
        this.loading = false
        this.dialogRef.close(true);
        this.flag.displayFlag(`Utilisateur ajouté avec succés !`, FlagType.success);
      },
      error: () => {
        this.loading = false
      }
    })
  }

  updateUser() {
    this.loading = true;
    // motDepasse field commented out -- generate a throwaway password for the backend.
    const randomPassword = this.generateRandomPassword();
    const body = {
      email: this.form.get('mail')?.value,
      password: randomPassword,
      password_confirmation: randomPassword,
      kind: "AGENCY_USER",
      agency_id: this.agencyId,
      title: this.form.get('title')?.value,
      first_name: this.form.get('firstName')?.value + ' ' + this.form.get('lastName')?.value,
      last_name: this.form.get('fonction')?.value,
      //fonction: this.form.get('fonction')?.value,
      phone_number: this.form.get('numTel')?.value?.number.replace(/\s/g, ''),
      image: (this.form.get('photo1')?.value == "") ? this.data.image : this.form.get('photo1')?.value
    }
  
    this.agencyService
      .updateAgencyUser(body, this.data.id)
      .subscribe({
        next: () => {
          this.loading = false
          this.dialogRef.close(true);
          this.flag.displayFlag(`Utilisateur modifié avec succés !`, FlagType.success);
          window.location.reload();
        },
        error: (err) => {
          this.loading = false;
          console.error("Failed to update user", err);
        },
    });
  }

  // motDepasse field commented out -- generates a throwaway password to satisfy the backend.
  generateRandomPassword(): string {
    return Math.random().toString(36).slice(-10) + 'Aa1!';
  }

  getAgencyByEmail(email: string) {
    this.agencyService.getAgencyByEmail(email).subscribe({
      next: (res: any) => {
        if (res[0] && res[0].id) {
          this.agencyId = res[0].id;
        } else {
          console.error("Response does not contain an ID");
        }
      },
      error: () => {
        this.loading = false
      }
    })
  }
}